import { FormattedMessage } from "react-intl";

import { Accordion } from "components/Accordion/Accordion";
import { Spinner } from "components/spinner/Spinner";
import { ErrorMessage } from "components/ErrorMessage/ErrorMessage";

export const Fq = ({ faqs, isLoading, error }) => {
	return (
		<section className="section">
			<div className="container-main">
				{/* Section Header */}
				<div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
					<span className="badge mb-4">Soporte</span>
					<h2 className="text-display-md md:text-display-lg text-primary mb-4">
						<FormattedMessage id="APP.NAV.FQ.LABEL" />
					</h2>
					<p className="text-body-lg text-surface-600">
						Encuentra respuestas a las preguntas más comunes sobre nuestros servicios
					</p>
				</div>

				{/* FAQ Content */}
				<div className="max-w-3xl mx-auto">
					{isLoading ? (
						<div className="flex justify-center items-center py-16">
							<Spinner />
						</div>
					) : (
						<>
							{error ? (
								<ErrorMessage
									image="warning.svg"
									descriptionKey="APP.GENERAL.ERROR.DESCRIPTION"
								/>
							) : faqs.length > 0 ? (
								<Accordion faqs={faqs} />
							) : (
								<ErrorMessage
									image="empty.svg"
									descriptionKey="APP.GENERAL.ERROR.EMPTY.DATA"
								/>
							)}
						</>
					)}
				</div>
			</div>
		</section>
	);
};
